<template>
	<div class="con1 fl_c fl_j_c fl_a_c">
		<!-- <div class="con1s fl_r fl_j_c fl_a_c">
			<img class="con1s_l" src="../assets/7.png" />
			<div class="con1s_r"> 免责声明：汇旺担保不参与也不了解客户的具体业务，我们作为担保方只负责一方收到货另一方收到钱，至于资金或者货物的来龙去脉，汇旺无法查证也无法保证，请买卖双方自行沟通好相关细节。资金或货物来源有问题或使用所购买货物从事违法行为，本公司概不承担连带责任。 </div>
		</div> -->
		<div class="con1s_b">未经绍兴零工网同意，不得转载本网站之所有招聘信息及作品 绍兴零工网版权所有</div>
		<div class="con1s_c">浙ICP备2023011427号-1</div>
		<div class="con1s_d">网上有害信息举报专区 违法不良信息举报电话：400-885-9898 关爱未成年举报热线:400-885-9898-7 绍兴市人力资源与社会保障局 监督电话 </div>
	</div>
</template>
<script>
	export default {
		name: 'footers',
		data () {
			return {}
		},
		methods: {},
	}
</script>
<style lang="less" scoped>
	.con1 {
		width: 100%;
		height: 131px;
		background: #151B21;

		.con1s_b {
			width: 100%;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #fff;
			line-height: 14px;
			text-align: center;
		}

		.con1s_c {
			width: 100%;
			background: #151B21;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #fff;
			text-align: center;
		}

		.con1s_d {
			width: 100%;
			background: #151B21;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #fff;
			text-align: center;
		}
	}
</style>